export default "__VITE_ASSET__BgXuiyrb__"